import SockJS from 'sockjs-client'
import Stomp from 'webstomp-client'

const env = (process.env.NODE_ENV === 'production')

export default {
  state: {
    socket: null,
    stomp: null,
    subscribeIds: {},
    isConnected: false,
    subscribeQueue: []
  },
  getters: {
    'socket:stomp': state => state.stomp,
    'socket:isConnected': state => state.isConnected
  },
  actions: {
    socketConnect ({ commit, dispatch, state, getters }) {
      let url = env ? 'http://192.168.0.46' : 'http://localhost'
      let port = ':15040'
      state.socket = new SockJS(url + port + '/fdc/mts/ws-stomp')
      state.stomp = Stomp.over(state.socket, { heartbeat: false, debug: true })
      state.stomp.connect({}, frame => {
        state.isConnected = true
      })
    },
    subscribe ({ state, commit }, data) {
      if (!state.isConnected) {
        commit('ADD_SUBSCRIPTION_QUEUE', data)
      } else if (!state.subscribeIds[data.url]) {
        let subscribeId = state.stomp.subscribe(data.url, data.callback)
        state.subscribeIds[data.url] = subscribeId
      }
    },
    unsubscribe ({ state }, data) {
      if (state.subscribeIds[data.url]) {
        state.subscribeIds[data.url].unsubscribe()
        delete state.subscribeIds[data.url]
      }
    },
    socketDisconnect ({ state }) {
      state.stomp.disconnect()
    }
  },
  mutations: {
    ADD_SUBSCRIPTION_QUEUE (state, payload) {
      state.subscribeQueue.push(payload)
    },
    CLEAR_SUBSCRIPTION_QUEUE (state) {
      state.subscribeQueue = []
    }
  }
}
